export default "__VITE_ASSET__ChJfq6Rl__"